module.exports = __webpack_public_path__ + "img/148f3e5549dc6a2b2d2b6a041f2d0c1c.140846cc.png";